import useList from '../_basic/list';
import useItem from '../_basic/item';
import schemas from './schemas.graphql';
import itemSchema from './item.graphql';
import provider from '@/api/apollo-client';
import gqlItem from '@/api/notifications/item.graphql';

const customFields = [
  {
    field: 'name',
    value: 'name',
    text: 'Name'
  },
  {
    field: 'favorites',
    value: 'favorites',
    text: 'Favorites'
  },
  {
    field: 'muted',
    value: 'muted',
    text: 'Muted'
  },
  {
    field: 'status',
    value: 'status',
    text: 'Status'
  },
  {
    field: 'batteryType',
    value: 'batteryType',
    text: 'Battery type'
  },
  {
    field: 'batteryLevel',
    value: 'batteryLevel',
    text: 'Battery level'
  },
  {
    field: 'emulation',
    value: 'emulation',
    text: 'Emulation'
  },
  {
    field: 'schemaName',
    value: 'schemaName',
    text: 'Driver name'
  }
];

export default function(filters) {
  const object = new useItem(itemSchema);
  const objects = new useList(schemas, filters);

  objects.fields.value = customFields;
  objects.visibleFields.value = objects.fields.value.map(i => i.key);

  return {
    objects,
    object: {
      ...object,
      linkObjectToObject: data => {
        return provider.mutate({
          mutation: itemSchema.connectObjectsToObject,
          variables: {
            input: data
          }
        });
      },
      unlinkObjectToObject: data => {
        return provider.mutate({
          mutation: itemSchema.disconnectObjectsToObject,
          variables: {
            input: data
          }
        });
      },
      updateObjectProperty: data => {
        return provider.mutate({
          mutation: itemSchema.updateObjectProperty,
          variables: {
            input: data
          }
        });
      },
      updateObjectProperties: data => {
        return provider.mutate({
          mutation: itemSchema.updateObjectProperties,
          variables: {
            input: data
          }
        });
      },
      updateObjectPropertiesNoCache: data => {
        return provider.mutate({
          mutation: itemSchema.updateObjectProperties,
          variables: {
            input: data
          },
          fetchPolicy: 'no-cache'
        });
      },
      createControlsExecution: data => {
        return provider.mutate({
          mutation: itemSchema.createControlsExecution,
          variables: {
            input: data
          }
        });
      },
      muteObject: data => {
        return provider.mutate({
          mutation: itemSchema.muteObject,
          variables: {
            input: data
          }
        });
      },
      addToFavorite: data => {
        return provider.mutate({
          mutation: itemSchema.addToFavorite,
          variables: {
            input: data
          }
        });
      },
      getHistoryControls: data => {
        return provider.query({
          query: itemSchema.getControls,
          variables: {
            ...data
          },
          fetchPolicy: 'no-cache'
        });
      },
      getPropertiesHistory: data => {
        return provider.query({
          query: itemSchema.getPropertiesHistory,
          variables: {
            ...data
          },
          fetchPolicy: 'no-cache'
        });
      },
      subscribeObject: data => {
        return provider.subscribe({
          variables: data,
          query: itemSchema.subscribeObject
        });
      },
      subscribeRpc: data => {
        return provider.subscribe({
          variables: data,
          query: itemSchema.RpcSubscribe
        });
      },
      getObjectProperty: id => {
        return provider.query({
          variables: {
            id
          },
          query: itemSchema.getObjectProperty
        });
      },
      getControlExecution: data => {
        return provider.query({
          variables: data,
          query: itemSchema.getControlExecutions,
          fetchPolicy: 'no-cache'
        });
      },
      getReportsForControlExecution: data => {
        return provider.query({
          variables: data,
          query: itemSchema.getReportsForControlExecution,
          fetchPolicy: 'no-cache'
        });
      }
    }
  };
}
